import { clearDrawerReturn } from './drawer-return';
import { resolveNotificationTarget } from './notification-target';

type ReturnOrigin = string | string[] | undefined;
const HUB_HREF = '/cv/my-tabbio';

export function withMyTabbioReturn(href: string, returnTo: ReturnOrigin): string {
  const origin = Array.isArray(returnTo) ? returnTo[0] : returnTo;
  return origin === 'my-tabbio'
    ? `${href}${href.includes('?') ? '&' : '?'}returnTo=my-tabbio`
    : href;
}

export function openMyTabbioActivity(
  router: { push: (href: any) => void },
  destination: '/messages' | '/notifications',
) {
  clearDrawerReturn();
  router.push(withMyTabbioReturn(destination, 'my-tabbio'));
}

/**
 * Where a notification opened from the hub's Notifications pop-out goes. A
 * conversation or the full lists keep the hub as their bounded return; every
 * other target (a job, a run, settings) is unchanged. Deliberately not
 * `withNotificationListOrigin`: that would send Back from a job to a
 * Notifications page the user never opened.
 */
export function resolveMyTabbioNotificationTarget(data: unknown): string | null {
  const target = resolveNotificationTarget(data);
  if (!target) return null;
  return target.startsWith('/messages') || target.startsWith('/notifications')
    ? withMyTabbioReturn(target, 'my-tabbio')
    : target;
}

/** Only the known hub origin may override history; deep links keep normal Back. */
export function closeMyTabbioActivity(
  router: {
    canGoBack: () => boolean;
    back: () => void;
    dismissTo: (href: any) => void;
    replace: (href: any) => void;
  },
  returnTo: ReturnOrigin,
) {
  const origin = Array.isArray(returnTo) ? returnTo[0] : returnTo;
  if (origin === 'my-tabbio') {
    clearDrawerReturn();
    router.dismissTo(HUB_HREF);
  } else if (router.canGoBack()) {
    router.back();
  } else {
    router.replace('/');
  }
}
